import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import { getMiniIfaPreviewAsync, getBomAndChartPreviewAsync } from 'src/services/costModelling/shouldCostLibrary.services'

const initialState = {
  modelDetailsLoader: false,
  modelDetailsData: {},
  modelDetailsError: '',
}

export const getSCModelDetailsSlice = createSlice({
    name: 'get-models-details-data',
    initialState,
    extraReducers: (builder) => {
        builder.addMatcher(isAnyOf(getMiniIfaPreviewAsync.pending), (state) => {
            state.modelDetailsLoader = true
        })
        builder.addMatcher(isAnyOf(getMiniIfaPreviewAsync.fulfilled), (state, action) => {
            state.modelDetailsLoader = false
            state.modelDetailsData = { ...state.modelDetailsData, ...action.payload.data }
            state.commodityLastUpdatedDate = action.payload.last_updated_date
        })
        builder.addMatcher(isAnyOf(getMiniIfaPreviewAsync.rejected), (state, action) => {
            state.modelDetailsLoader = false
            state.modelDetailsError = action.payload.message
        })

        builder.addMatcher(isAnyOf(getBomAndChartPreviewAsync.pending), (state) => {
            state.modelDetailsLoader = true
        })
        builder.addMatcher(isAnyOf(getBomAndChartPreviewAsync.fulfilled), (state, action) => {
            state.modelDetailsLoader = false
            state.modelDetailsData = { ...state.modelDetailsData, ...action.payload.data }
            state.commodityLastUpdatedDate = action.payload.last_updated_date
        })
        builder.addMatcher(isAnyOf(getBomAndChartPreviewAsync.rejected), (state, action) => {
            state.modelDetailsLoader = false
            state.modelDetailsError = action.payload.message
        })
    },
    reducers: {
        resetModelDetailsDataSlice: () => initialState,
    },
})

export const { resetModelDetailsDataSlice } = getSCModelDetailsSlice.actions

export default getSCModelDetailsSlice.reducer
